// extracted by mini-css-extract-plugin
export default {"title":"poc_title__rfpLc","wrapper":"poc_wrapper__6bEcN","nextBtn":"poc_nextBtn__Ocytn"};